<template>
  <div class="share-guide-shade" v-if="showShade" @click="handleClose">
    <img src="https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659764167645.png" alt="" class="guide-shade-tips">
    <img src="https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659764209047.png" alt="" class="guide-shade-btn" @click="handleClose">
  </div>
</template>
<script>
export default {
  name: 'shareGuide',
  data() {
    return {
      showShade: false,
    }
  },
  methods: {
    handleOpen() {
      this.showShade = true;
    },
    handleClose() {
      this.showShade = false;
    }
  }
}
</script>
<style lang="stylus" scoped>
  .share-guide-shade {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.8);
    z-index: 999;
    .guide-shade-tips {
      width: 558px;
      margin-top: 40px;
    }
    .guide-shade-btn {
      width: 215px;
    }
    img {
      margin: 0 auto;
      display: block;
      margin-bottom: 24px;
    }
  }
</style>